module.exports = __webpack_public_path__ + "img/EnerArk 1.8b477194.svg";